import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-query'
import ApiClient from 'data/api/api_client'
import Link from 'components/Link'
import Image from 'components/Image'

const ArticleAuthor = ({ slug }: { slug: string }) => {
  const { data: author } = useQuery('author', () => ApiClient.magazine.getAuthor(slug))

  return (
    <>
      {
        author
        && <>
          <hr className="border-input-border mb-50" />
          <div className="text-center lg:text-left mb-50 lg:mb-0">
            <p className="uppercase font-poppins text-12 md:text-14 text-grey-650 mb-26 tracking-1/2">
              About the Author
            </p>

            <div className="max-w-[450px] mx-auto lg:max-w-full flex flex-col lg:flex-row items-center lg:items-start gap-14 lg:gap-[35px]">
              <Link href={`/magazine/authors/${author.slug}`}>
                <Image
                  src={author.profileImage.src}
                  className="object-cover object-center rounded-full"
                  width={120}
                  height={120}
                  alt="Author Profile Image"
                />
              </Link>

              <div className="space-y-15">
                <p className="font-serif font-bold text-blue-1000 text-20 md:text-24 leading-28">{author.name}</p>
                <div className="text-14 text-grey-750" dangerouslySetInnerHTML={{ __html: author.bio }} />
              </div>

              <div className="hidden ml-auto lg:block">
                <Link href={`/magazine/authors/${author.slug}`} className="border-black border rounded-4 border-opacity-30 uppercase px-[34px] py-[16px] text-grey-900 whitespace-nowrap hover:bg-primary hover:border-primary hover:border-opacity-100 hover:text-white">
                  View Profile
                </Link>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}

ArticleAuthor.propTypes = {
  slug: PropTypes.string,
}

export default ArticleAuthor
